export default "__VITE_ASSET__080fecf6__"